import * as z from 'zod';
export {
  CancelFoodOrderModal,
  CreateTestFoodOrderModal,
} from './ui/food-order-action-modals';
export const cancelFoodOrderPayloadSchema = z.object({
  orderId: z.string().min(1),
  orderNumber: z.union([z.string(), z.number()]).optional(),
});
export const createTestFoodOrderPayloadSchema = z.object({});
declare module '@noor/lib' {
  interface ModalRegistry {
    'cancel-food-order': z.infer<typeof cancelFoodOrderPayloadSchema>;
    'create-test-food-order': z.infer<typeof createTestFoodOrderPayloadSchema>;
  }
}
